import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import {withSnackbar} from "notistack";
import {withStyles} from '@material-ui/core/styles';
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = theme => ({});

const INITIAL_STATE = {
    open: false,
    value: ""
};

class AddDocOptionsDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;
        window.location.pathname.toLowerCase().includes("debug") && console.log ('AddDocOptionsDialog props= ' , props);
    }

    componentDidMount(){
        this.setState({ open: true })
    }

    handleCancel = () => {
        this.setState({ open: false });
        this.props.handleCloseDialog("")
    }

    handleConfirm = () => {
        this.setState({ open: false });
        this.props.handleCloseDialog(this.state.value)
    }


    handleChange = (event) => {
        this.setState({value: event.target.value})
    }

    render() {

        const templateOptions = this.props.templateOptions;
        const uploadConfig = this.props.uploadConfig;
        const dialogTitle = uploadConfig.dialogTitle ? uploadConfig.dialogTitle : "Add document";

        return (
            <div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Confirm file source and click continue
                        </DialogContentText>

                        <FormControl component="fieldset" style={{paddingLeft: "24px"}}>
                            <RadioGroup aria-label="decision" name="decision" value={this.state.value} onChange={this.handleChange}>
                                {
                                    //for each templating option listed in templates, give the option to select
                                    templateOptions.map(templateOption => {
                                        let templateConfig = this.props.templatesConfig ? this.props.templatesConfig[templateOption] : {};
                                        window.location.pathname.toLowerCase().includes("debug") && console.log ('templateConfig =' , templateConfig);
                                        if (templateConfig) {
                                            return (<FormControlLabel value= {templateOption} control={<Radio/>} label={templateConfig.label} />)
                                        } else {
                                            window.location.pathname.toLowerCase().includes("debug") && console.log ('Template Config not found for: ', templateOption)
                                            this.props.enqueueSnackbar("Template config not found for: " + templateOption, {variant: 'error'})
                                            return(<React.Fragment/>)
                                        }
                                    })
                                }
                                {
                                    this.props.showUploadOption &&
                                    <FormControlLabel value={"upload"} control={<Radio/>} label={"Upload"}/>
                                }
                            </RadioGroup>
                        </FormControl>

                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.handleCancel} variant="contained">Cancel</Button>
                        <Button onClick={this.handleConfirm} variant="contained" color="secondary" disabled={this.state.value === ""}>Continue</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

AddDocOptionsDialog.propTypes = {
    classes: PropTypes.object,
    handleCloseDialog: PropTypes.func.isRequired,
    templateOptions: PropTypes.array.isRequired,
    templatesConfig: PropTypes.object.isRequired,
    showUploadOption: PropTypes.bool.isRequired,
    uploadConfig: PropTypes.object.isRequired
};

export default withSnackbar(withStyles(styles, { withTheme: true })(AddDocOptionsDialog));